import { render } from "./FlightLegs.vue?vue&type=template&id=940842bc&scoped=true"
import script from "./FlightLegs.vue?vue&type=script&lang=js"
export * from "./FlightLegs.vue?vue&type=script&lang=js"

import "./FlightLegs.vue?vue&type=style&index=0&id=940842bc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-940842bc"]])

export default __exports__